import { LogLevel, OpenIdConfiguration } from "angular-auth-oidc-client";
import { environment } from "src/environments/environment";

export const AuthConfig: OpenIdConfiguration = {
    authority: environment.auth.authority,
    redirectUrl: environment.auth.redirectUri,
    postLogoutRedirectUri: environment.auth.redirectUri,
    clientId: environment.auth.clientId,
    responseType: 'code',
    scope: 'openid offline_access',
    silentRenew: true,
    useRefreshToken: true,
    logLevel: environment.auth.loglevel,
    secureRoutes: [
        environment.wsBaseUrl,
    ]
}
